import React, { useState } from "react"
import PropTypes from "prop-types"
import "./Avatar.scss"

import { twemojify } from "../../util/twemojify"

import Text from "../text/Text"
import RawIcon from "../system-icons/RawIcon"

import ImageBrokenSVG from "../../public/res/svg/image-broken.svg"
import { avatarInitials } from "../../util/common"
import AvatarSmsIcon from "../../../Icons/AvatarSms"
import SmsIcon from "../../../Icons/SmsIcon"
import cons from "../../client/state/cons"
import initMatrix from "../../client/initMatrix"

import IndicatorAvailableIcon from "../../../Icons/IndicatorAvailable"
import IndicatorApawayIcon from "../../../Icons/IndicatorApaway"
import IndicatorBusyIcon from "../../../Icons/IndicatorBusy"
import IndicatorDndIcon from "../../../Icons/IndicatorDnd"
import IndicatorBrbIcon from "../../../Icons/IndicatorBrb"
import IndicatorOfflineIcon from "../../../Icons/IndicatorOffline"

const Avatar = React.forwardRef(
  ({ text, bgColor, iconSrc, iconColor, imageSrc, size, roomType, userId, roomId }, ref) => {

    let userPresenceStatus
    const mx = initMatrix.matrixClient

    if (userId) {
      const user = mx.getUser(userId)

      userPresenceStatus = user?.presenceStatusMsg || user?.presence

      console.log({ user })
    }

    if (roomId) {
      const room = mx.getRoom(roomId)

      if (room && (room.getJoinedMemberCount() == 2)) {
        if (room.getAvatarFallbackMember()?.user) {
          userPresenceStatus = room.getAvatarFallbackMember()?.user?.presenceStatusMsg || room.getAvatarFallbackMember()?.user?.presence
        } else {
          const user = mx.getUser(room.getJoinedMembers().find((user) => user.userId != mx.getUserId())?.userId)
          userPresenceStatus = user?.presenceStatusMsg || user?.presence
        }

        console.log({ uss: room.getJoinedMembers().find((user) => user.userId != mx.getUserId())?.user })
      }
    }

    const [isImageWorking, setIsImageWorking] = useState(true)
    let textSize = "s1"
    if (size === "large") textSize = "h1"
    if (size === "small") textSize = "b1"
    if (size === "extra-small") textSize = "b3"

    return (
      <div
        ref={ref}
        className={`avatar-container avatar-container__${size} noselect`}
      >
        {Boolean(imageSrc) && isImageWorking ? (
          <img
            draggable="false"
            src={imageSrc?.startsWith("mxc") ? initMatrix?.matrixClient?.mxcUrlToHttp(
              imageSrc
            ) : imageSrc}
            onLoad={(e) => {
              e.target.style.backgroundColor = "transparent"
            }}
            onError={(e) => {
              setIsImageWorking(false)
              e.target.src = ImageBrokenSVG
            }}
            alt=""
          />
        ) : roomType === cons.roomType.SMSMMS_GROUPS ||
          roomType === cons.roomType.SMSMMS_DM ? (
          <span className="sms-avatar">
            <SmsIcon />
          </span>
        ) : (
          <span
            style={{
              backgroundColor: iconSrc === null ? bgColor : "transparent"
            }}
            className={`avatar__border${iconSrc !== null ? "--active" : ""}`}
          >
            {iconSrc !== null ? (
              <RawIcon size={size} src={iconSrc} color={iconColor} />
            ) : (
              text !== null && (
                <Text variant={textSize} primary>
                  {twemojify(avatarInitials(text))}
                </Text>
              )
            )}
          </span>
        )}

        {userPresenceStatus && (roomType !== cons.roomType.SMSMMS_GROUPS) && (roomType !== cons.roomType.SMSMMS_DM) && (roomType !== cons.roomType.CHANNELS) && (
          <div className="presence-room">
            {userPresenceStatus === "online" ? (
              <IndicatorAvailableIcon />
            ) : userPresenceStatus === "Away" ? (
              <IndicatorApawayIcon />
            ) : userPresenceStatus === "Busy" ? (
              <IndicatorBusyIcon />
            ) : userPresenceStatus === "Do not disturb" ? (
              <IndicatorDndIcon />
            ) : userPresenceStatus === "Be right back" ? (
              <IndicatorBrbIcon />
            ) : (
              <IndicatorOfflineIcon />
            )}
          </div>
        )}
      </div>
    )
  }
)

Avatar.defaultProps = {
  text: null,
  bgColor: "transparent",
  iconSrc: null,
  iconColor: null,
  imageSrc: null,
  size: "normal"
}

Avatar.propTypes = {
  text: PropTypes.string,
  bgColor: PropTypes.string,
  iconSrc: PropTypes.string,
  iconColor: PropTypes.string,
  imageSrc: PropTypes.string,
  size: PropTypes.oneOf(["large", "normal", "small", "extra-small"])
}

export default Avatar
export { Avatar }
